module.exports = __webpack_public_path__ + "static/media/Sompo.37fc81de.jpg";